import classnames from "classnames";
import React from "react";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import contactMethods from "../../constants/contactMethods";

// Styles
import styles from "./contact-us-help-order-solution.module.scss";

function ContactUsHelpOrderSolution({ solution: { id, fields }, className }) {
  const locationOnPage = "main | contact-us";

  return (
    <article className={classnames(styles.helpOrderSolution, className)} data-solution-id={id}>
      <h2 className={styles.helpOrderSolution__top}>Did you know...</h2>
      <div className={styles.helpOrderSolution__inner}>
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType="primary"
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
          title={"We’re here to help"}
          viewContactDetails
          showContactDetailsByDefault
          showGreyBackground
        />
      </div>
    </article>
  );
}

export default ContactUsHelpOrderSolution;
